module.exports = __webpack_public_path__ + "img/04.69e5a36b.jpg";